import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { UsuarioActual } from '@/views/a-login/login-controlador';
import router from '@/__env/router.index';
import { Utiles } from '@/__env/pluggins/event-bus';

export class ControladorBase
{
    public get Usuario() { return UsuarioActual; }



    public readonly Vista = new VistaBase();
    public readonly Router = new RouterBase();
}

export class VistaBase
{
    protected titulo: string = 'Sistema';
    public ModoEnQuery: boolean = true;
    public get Titulo(): string { return this.titulo; }
    public set Titulo( x: string ) { this.titulo = x; document.title = this.titulo; }

    public get SubTitulo(): string
    {
        let e = this.Opciones.find( x => x.Modo == this.modo );
        if ( e )
            return e.Titulo;
    }
    public readonly Menu = new MenuBase();
    public readonly BarraIzquierda = new MenuBase();
    public readonly BarraDerecha = new MenuBase();
    public readonly BarraArriba = new MenuBase();
    public readonly BarraDebajo = new MenuBase();

    public Opciones: OpcionMenu[] = [];
    public AccesosDirectos: OpcionMenu[] = [];

    protected modo: string = 'inicio';
    get Modo(): string { return this.modo; }
    set Modo( m: string )
    {
        this.modo = m;

        if ( this.ModoEnQuery )
            Utiles.setQuery( { m: this.modo } );
        this._onModo.dispatch();
        //this._onEditarQuery.dispatch( this.query + '&m=' + this.modo );

    }
    private _onModo = new SignalDispatcher();
    public get onModo() { return this._onModo.asEvent(); }

    protected query: string = '';
    public set Query( x: string )
    {
        this.query = x;
        this._onEditarQuery.dispatch( x );
    }

    private _onEditarQuery = new SimpleEventDispatcher<string>
        ();
    public get onEditarQuery() { return this._onEditarQuery.asEvent(); }

    protected submodo: string = 'vacio';
    get SubModo(): string { return this.submodo; }
    set SubModo( m: string ) { this.submodo = m; this._onSubModo.dispatch(); }
    private _onSubModo = new SignalDispatcher();
    public get onSubModo() { return this._onSubModo.asEvent(); }

    protected estado: string = 'cargando';
    get Estado(): string { return this.estado; }
    set Estado( m: string ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }

    protected buscador: string = 'ninguno';
    get Buscador(): string { return this.buscador; }
    set Buscador( m: string ) { this.buscador = m; this._onBuscador.dispatch(); }
    private _onBuscador = new SignalDispatcher();
    public get onBuscador() { return this._onBuscador.asEvent(); }

    public ReservarEspacioArriba = new ReservarEspacio();
    public ReservarEspacioAbajo = new ReservarEspacio();
    public ReservarEspacioIzquierda = new ReservarEspacio();
    public ReservarEspacioDerecha = new ReservarEspacio();
}

export class MenuBase
{
    protected abierto: boolean = false;
    get Abierto(): boolean { return this.abierto; }
    set Abierto( m: boolean ) { this.abierto = m; this._onAbierto.dispatch(); }

    protected abiertoManual: boolean = false;
    get AbiertoManual(): boolean { return this.abiertoManual; }
    set AbiertoManual( m: boolean ) { this.abiertoManual = m; }

    private _onAbierto = new SignalDispatcher();
    public get onAbierto() { return this._onAbierto.asEvent(); }
    public Alternar()
    {
        this.Abierto = !this.Abierto;
    }

    public Datos: any = {};
    public Altura = new ReservarEspacio();
    public Anchura = new ReservarEspacio();

    protected modo: string = '';
    get Modo(): string { return this.modo; }
    set Modo( m: string ) { this.modo = m; this._onModo.dispatch(); }
    private _onModo = new SignalDispatcher();
    public get onModo() { return this._onModo.asEvent(); }

    protected submodo: string = '';
    get SubModo(): string { return this.submodo; }
    set SubModo( m: string ) { this.submodo = m; this._onSubModo.dispatch(); }
    private _onSubModo = new SignalDispatcher();
    public get onSubModo() { return this._onSubModo.asEvent(); }

    protected estado: string = 'cargando';
    get Estado(): string { return this.estado; }
    set Estado( m: string ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }


}

export class ReservarEspacio
{
    protected espacio: number | string = 0;
    get Espacio(): number | string { return this.espacio; }
    set Espacio( m: number | string ) { this.espacio = m; this._onEspacio.dispatch(); }
    private _onEspacio = new SignalDispatcher();
    public get onEspacio() { return this._onEspacio.asEvent(); }
}

export class FiltrosBase
{
    protected abierto: boolean = false;
    get Abierto(): boolean { return this.abierto; }
    set Abierto( m: boolean ) { this.abierto = m; this._onAbierto.dispatch(); }
    private _onAbierto = new SignalDispatcher();
    public get onAbierto() { return this._onAbierto.asEvent(); }

    protected modo: string = 'resumen';
    get Modo(): string { return this.modo; }
    set Modo( m: string ) { this.modo = m; this._onModo.dispatch(); }
    private _onModo = new SignalDispatcher();
    public get onModo() { return this._onModo.asEvent(); }
}

export class RouterBase
{
    Atras()
    {
        router.back();
    }

    Recargar()
    {
        window.location.reload();
    }

    Inicio()
    {
        router.push( '/inicio' );
    }
}


export type OpcionMenu = {
    Icono?: string,
    Titulo?: string,
    Subtitulo?: string,
    Modo?: string,
    Resaltado?: boolean,
    Oculto?: boolean,
    Desactivado?: boolean,
    Accion?: Function,
    Tipo: 'opcion' | 'titulo',
};
